"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.OsmosysDiv = (_a) => {
    var { opacity, children, className, osysName, border, borderBottom, borderTop, borderLeft, borderRight, shadow, minWidth, maxWidth, style, padding, innerRef, rounded, asLink, flexFill, flexCentered, flexCol, flexColCenteredFilled, flexRowCenteredFilled, flexRowFilled, flexColFilled, flexColCentered, flexRowCentered, flexRow, margin, marginY, marginX, marginBottom, marginRight, marginLeft, marginTop, bg, dataOpen, width, flexGrow } = _a, props = tslib_1.__rest(_a, ["opacity", "children", "className", "osysName", "border", "borderBottom", "borderTop", "borderLeft", "borderRight", "shadow", "minWidth", "maxWidth", "style", "padding", "innerRef", "rounded", "asLink", "flexFill", "flexCentered", "flexCol", "flexColCenteredFilled", "flexRowCenteredFilled", "flexRowFilled", "flexColFilled", "flexColCentered", "flexRowCentered", "flexRow", "margin", "marginY", "marginX", "marginBottom", "marginRight", "marginLeft", "marginTop", "bg", "dataOpen", "width", "flexGrow"]);
    style = Object.assign({ maxWidth,
        minWidth,
        opacity,
        width }, style);
    style.zIndex =
        typeof style.zIndex === 'undefined' && shadow ? 1 : style.zIndex;
    const isRow = flexRowCenteredFilled || flexRow || flexRowFilled || flexRowCentered;
    const isCol = !isRow &&
        (flexCol || flexColCenteredFilled || flexColFilled || flexColCentered);
    const isCentered = flexCentered ||
        flexRowCenteredFilled ||
        flexColCenteredFilled ||
        flexRowCentered ||
        flexColCentered;
    const isFilled = flexFill ||
        flexRowCenteredFilled ||
        flexColCenteredFilled ||
        flexRowFilled ||
        flexColFilled;
    return react_1.default.createElement(asLink ? 'a' : 'div', Object.assign({ className: classnames_1.default(className, (shadow === 'sm' || shadow === 'lg') && `shadow-${shadow}`, shadow === true && 'shadow-sm', padding === 'sm' && 'p-1', padding === true && 'p-2', padding === 'x' && 'px-2', padding === 'y' && 'py-2', rounded === true && 'rounded', (rounded === 'sm' || rounded === 'lg') && `rounded-${shadow}`, {
            [`bg-${bg}`]: !!bg,
            border: border,
            'border-bottom': borderBottom,
            'border-left': borderLeft,
            'border-right': borderRight,
            'border-top': borderTop,
            'flex-col': isCol,
            'flex-grow-1': flexGrow === 1 || isFilled,
            [`flex-grow-${flexGrow}`]: flexGrow === 0,
            'flex-row': isRow,
            'justify-content-center': isCentered,
            'm-1': margin === 'sm',
            'm-2': margin === true,
            'm-3': margin === 'lg',
            'mb-1': marginBottom === 'sm' || marginY === 'sm',
            'mb-2': marginBottom === true || marginY === true,
            'mb-3': marginBottom === 'lg' || marginY === 'lg',
            'ml-1': marginLeft === 'sm' || marginX === 'sm',
            'ml-2': marginLeft === true || marginX === true,
            'ml-3': marginLeft === 'lg' || marginX === 'lg',
            'mr-1': marginRight === 'sm' || marginX === 'sm',
            'mr-2': marginRight === true || marginX === true,
            'mr-3': marginRight === 'lg' || marginX === 'lg',
            'mt-1': marginTop === 'sm' || marginY === 'sm',
            'mt-2': marginTop === true || marginY === true,
            'mt-3': marginTop === 'lg' || marginY === 'lg',
        }
        // centeredCol && 'flex-col-centered',
        // centeredRow && 'flex-row-centered',
        // full && 'flex-grow-1',
        // flex && 'd-flex',
        // row && 'flex-row'
        ), 'data-flex-centered': isCentered, 'data-flex-col': isCol, 'data-flex-filled': isFilled, 'data-flex-row': isRow, 'data-is-open': dataOpen, 'data-osmosys-comp': osysName, 'data-osmosys-comp-base': 'OsmosysDiv', ref: innerRef, style }, props), children);
};
//# sourceMappingURL=OsmosysDiv.js.map